// extracted by mini-css-extract-plugin
export default {"homepage":"home_homepage__d7w-t","description":"home_description__oX0ra","banner":"home_banner__jAfJF","textWrapper":"home_textWrapper__y1D66"};